import { render, staticRenderFns } from "./ResetPassModal.vue?vue&type=template&id=0cf99166&scoped=true&"
import script from "./ResetPassModal.vue?vue&type=script&lang=js&"
export * from "./ResetPassModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassModal.vue?vue&type=style&index=0&id=0cf99166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf99166",
  null
  
)

export default component.exports